import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useKineticMapLiveProjection } from 'components';
import LanePath from './LanePath';
import useLaneStyles from './styles';
import { LaneProps } from './types';
import { getLaneAnchorPoint } from './util';

const Lane: React.FunctionComponent<LaneProps> = ({
  lane,
  coordinates,
  departure,
  selected,
  onClickConnect,
  connectable,
  disabled,
  onClickLane,
  onMouseOut,
  onMouseOver,
}) => {
  const { anchorCoordinates, approaching } = useMemo(
    () => getLaneAnchorPoint(lane, coordinates),
    [lane, coordinates]
  );
  const { t } = useTranslation('common');
  const classes = useLaneStyles();
  const forward = !approaching;
  const arrowEnd = forward ? departure : !departure;
  const color = selected ? '#28aae1' : '#f49d22';

  const point = useKineticMapLiveProjection([...anchorCoordinates]);
  const buttonPosition = lane.id ? point : null;

  if (!lane?.geometry) {
    return null;
  }

  return (
    <g>
      <LanePath
        arrowEnd={arrowEnd}
        arrowStart={!arrowEnd}
        color={color}
        coordinates={lane.geometry.coordinates}
        disabled={disabled}
        lighten={departure && !selected}
        id={lane.id}
        onClick={onClickLane}
        onMouseOut={onMouseOut}
        onMouseOver={onMouseOver}
      />

      {connectable && buttonPosition && (
        <foreignObject
          className={classes.connectButton}
          x={buttonPosition.x}
          y={buttonPosition.y + 5}
          width={60}
          height={25}
          onClick={(e) => onClickConnect?.(e)}
        >
          <span>{t('connect')}</span>
        </foreignObject>
      )}
    </g>
  );
};

export default Lane;
